import { Injectable } from '@angular/core';
import { ConfigurationDataProvider } from '../configuration-data-provider';
import { SharedDataProvider } from '../shared-data-provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Task } from '../dto/task';

@Injectable()
export class TaskProvider {

    headers = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(public http: HttpClient, private config: ConfigurationDataProvider, private shared: SharedDataProvider) {
    }

    /**
     * List all tasks which belong to loggedin user.
     */
    public list() {
        console.log(JSON.stringify(this.shared.getTokenAuthData()));
        return this.http.post(this.config.taskURL + "list", JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    public save(task: Task) {
        console.log('Push task to insert method of service.');
        task.credentials = this.shared.getTokenAuthData();
        console.log(JSON.stringify(task));
        return this.http.post(this.config.taskURL + "new", JSON.stringify(task), { headers: this.headers });
    }

    public update(task: Task) {
        console.log('Push task to update method of service.');
        task.credentials = this.shared.getTokenAuthData();
        console.log(JSON.stringify(task));
        return this.http.put(this.config.taskURL + "id/" + task.id, JSON.stringify(task), { headers: this.headers });
    }

    public qryTask(id: number) {
        return this.http.post(this.config.taskURL + "id/" + id,
            JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    public delete(id: number) {
        console.log('Delete task ' + id);
        return this.http.post(this.config.taskURL + "del/" + id,
            JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    public activeTasks() {
        return this.http.post(this.config.taskURL + "activetasks",
            JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    public start(id : number) {
        return this.http.post(this.config.taskURL + "start/"+id,
            JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    public free(id : number) {
        return this.http.post(this.config.taskURL + "free/"+id,
            JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    public finish(id : number) {
        return this.http.post(this.config.taskURL + "finishtransport/"+id,
            JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    public finishSwitch(id : number, locationId : number) {
        return this.http.post(this.config.taskURL + "finishtransportswitch/"+id+"/"+locationId,
            JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
    }

    /*public load(first: number, pageSize: number, sortField: string, sortOrder: string, filterSet: any) {
        let paramSet: any = {};
        paramSet.credentials = this.shared.getTokenAuthData();
        paramSet.first = first;
        paramSet.pageSize = pageSize;
        paramSet.sortField = sortField;
        paramSet.sortOrder = sortOrder;
        paramSet.filters = filterSet;

        console.log("Load tasks filtered: " + JSON.stringify(paramSet));

        return this.http.post(this.config.taskURL + "filter", JSON.stringify(paramSet), { headers: this.headers })
    ;
    }*/
}



// WEBPACK FOOTER //
// ./src/providers/task/task.ts